import React from "react";
import { Conditions } from "./Conditions";
import { Box, Typography } from "@mui/material";

const TermsAndConditions = () => {
  return (
    <Box className="App" sx={{ display: "column" }}>
      <Box px={{ md: 15, xs: 2 }} pt={5}>
        <Typography
          textAlign={"center"}
          fontWeight={"bold"}
          fontSize={30}
          fontStyle={"Times New Roman"}
        >
          {" "}
          Term of Use
        </Typography>
        <Typography
          textAlign={"center"}
          fontWeight={"bold"}
          fontSize={30}
          fontStyle={"Times New Roman"}
        >
          {" "}
          Website Term of Use
        </Typography>
        {Conditions[0].pages.map((page) =>
          page.columns.map((column, index) =>
            column.paragraphs.map((paragraph, index) => (
              <Box>
                {paragraph.lines.map((line, index) =>
                  line.words.map((word, index) => (
                    <Typography
                      component={"span"}
                      key={index}
                      sx={{
                        left: `${word.left}px`,
                        top: `${word.top}px`,
                        width: `${word.width}px`,
                        height: `${word.height}px`,
                        color: word.color,
                        fontFamily: word.fontName,
                        fontSize: "20px",
                        fontWeight:
                          word.underline === "1" || word.fontWeight === "bold"
                            ? "bold"
                            : "none",
                        textDecoration:
                          word.underline === "1" ? "underline" : "none",
                        direction: word.dir,
                        transform: `rotate(${word.angle}deg)`,
                      }}
                    >
                      {word.text === "●" && <br />}
                      {word.text === "●" ? word.text : word.text + " "}
                    </Typography>
                  ))
                )}
              </Box>
            ))
          )
        )}
      </Box>
    </Box>
  );
};

export default TermsAndConditions;
